import { getStoreConfigs } from '../api/store';

export const checkFlag = async (
  flag: string,
  storeNumber: string
): Promise<boolean> => {
  let flagSetTo = false;

  try {
    const storeConfig = await getStoreConfigs({
      storeNumbers: [storeNumber],
      paramKeyNames: [flag],
    });

    if (
      storeConfig &&
      storeConfig.length > 0 &&
      storeConfig[0].configDetails &&
      storeConfig[0].configDetails.length > 0
    ) {
      flagSetTo = storeConfig[0].configDetails.some(
        (config) => config.paramValue == '1'
      );
    }
  } catch (eee) {
    // purposely left blank
    /* eslint-disable-next-line no-console */
    console.log('error retrieving flag.  Is DB setup yet ?');
  }

  return flagSetTo;
};
export const checkFlagWithDefault = async (
  flag: string,
  storeNumber: string,
  defaultValue: boolean
): Promise<boolean> => {
  let flagSetTo = defaultValue;

  try {
    const storeConfig = await getStoreConfigs({
      storeNumbers: [storeNumber],
      paramKeyNames: [flag],
    });

    if (
      storeConfig &&
      storeConfig.length > 0 &&
      storeConfig[0].configDetails &&
      storeConfig[0].configDetails.length > 0
    ) {
      flagSetTo = storeConfig[0].configDetails.some(
        (config) => config.paramValue == '1'
      );
    }
  } catch (eee) {
    // purposely left blank
    /* eslint-disable-next-line no-console */
    console.log('error retrieving flag.  Is DB setup yet ?');
  }

  return flagSetTo;
};

export type FlagSetTo = {
  readonly flagName: string;
  readonly flagValue: boolean;
};
export const checkFlags = async (
  flags: string[],
  storeNumber: string
): Promise<FlagSetTo[]> => {
  const out: FlagSetTo[] = [];
  try {
    const storeConfig = await getStoreConfigs({
      storeNumbers: [storeNumber],
      paramKeyNames: flags,
    });

    if (
      storeConfig &&
      storeConfig.length > 0 &&
      storeConfig[0].configDetails &&
      storeConfig[0].configDetails.length > 0
    ) {
      storeConfig[0].configDetails.forEach((oneConfig) => {
        const oneFlagSetTo: FlagSetTo = {
          flagName: oneConfig.paramKeyName,
          flagValue: oneConfig.paramValue == '1' ? true : false,
        };

        out.push(oneFlagSetTo);
      });
    }
  } catch (eee) {
    // purposely left blank
    /* eslint-disable-next-line no-console */
    console.log('error retrieving flags.  Is DB setup yet ?');
  }

  return out;
};
